<template>
  <VueApexCharts
    type="radialBar"
    :height="height"
    :options="chartOptions"
    :series="value"
  />
</template>

<script lang="ts" setup>
import VueApexCharts from 'vue3-apexcharts'
import { ref } from 'vue'

const props = defineProps({
  height: {
    type: String,
    default: '200'
  },
  value: {
    type: Array,
    required: true,
    default: () => []
  },
  options: {
    type: Object,
    default: () => ({})
  }
})

const chartOptions = ref({
  chart: {
    type: 'radialBar'
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: '70%'
      },
      dataLabels: {
        name: {
          // color: '#fff'
          fontSize: '14px',
          offsetY: 30
        },
        value: {
          show: true,
          // color: '#333',
          fontSize: '30px',
          fontWeight: '100',
          offsetY: -5
        }
      }
    }
  },
  labels: ['Profit'],
  stroke: {
    colors: ['#595478']
  },
  ...props.options
})
</script>
